(function($) {
    $(document).ready(function() {
        // Show modal popup with order form
        $('.catalog-course__button--demo-online').magnificPopup({
            items: {
                src: '#catalog-course-button-demo-form',
                type: 'inline'
            }
        });
    });
})(jQuery);
